module.exports = __webpack_public_path__ + "img/order-message.b4339b76.svg";